'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck } from '@subframe/core';
import type { ReactNode } from 'react';
import { Badge } from '@/shared/components/ui';
import type { ProdutoCatalogo } from '../types';
interface ProdutoCardProps {
  produto: ProdutoCatalogo;
  icone: ReactNode;
  selecionado: boolean;
  onAlternar: () => void;
}
export const ProdutoCard = t0 => {
  const $ = _c(29);
  const {
    produto,
    icone,
    selecionado,
    onAlternar
  } = t0;
  const t1 = `focus-visible:ring-brand-600/20 flex w-full cursor-pointer items-start gap-4 rounded-[16px] border border-solid p-5 text-left transition-all duration-200 focus-visible:ring-4 focus-visible:outline-none ${selecionado ? "border-brand-600 bg-brand-50 border-2" : "border-neutral-200 bg-white hover:border-neutral-300 hover:bg-neutral-50"}`;
  const t2 = `mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-[6px] border border-solid transition-colors ${selecionado ? "border-brand-600 bg-brand-600" : "border-neutral-300 bg-white"}`;
  let t3;
  if ($[0] !== selecionado) {
    t3 = selecionado && <FeatherCheck className="text-[13px] text-white" />;
    $[0] = selecionado;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== icone) {
    t5 = <span className="flex h-10 w-10 flex-none items-center justify-center rounded-[10px] bg-neutral-50">{icone}</span>;
    $[5] = icone;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== produto.badge) {
    t6 = produto.badge && <Badge variant="brand">{produto.badge}</Badge>;
    $[7] = produto.badge;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <span className="flex w-full items-start justify-between gap-3">{t5}{t6}</span>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== produto.titulo) {
    t8 = <span className="text-heading-dark text-base font-semibold">{produto.titulo}</span>;
    $[12] = produto.titulo;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== produto.descricao) {
    t9 = <span className="text-label-muted text-sm leading-relaxed">{produto.descricao}</span>;
    $[14] = produto.descricao;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== produto.nota) {
    t10 = <span className="text-[12.5px] font-medium text-neutral-500">{produto.nota}</span>;
    $[16] = produto.nota;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t11 = <span className="flex min-w-0 flex-1 flex-col gap-2">{t7}{t8}{t9}{t10}</span>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== onAlternar || $[24] !== selecionado || $[25] !== t1 || $[26] !== t11 || $[27] !== t4) {
    t12 = <button type="button" role="checkbox" aria-checked={selecionado} onClick={onAlternar} className={t1}>{t4}{t11}</button>;
    $[23] = onAlternar;
    $[24] = selecionado;
    $[25] = t1;
    $[26] = t11;
    $[27] = t4;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};